export default "__VITE_ASSET__GeFaNdIv__"